import * as analytic from '@anm/analytic';
import browserStore from '@anm/helpers/browserStore';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { ProjectFolderTreeModalContext } from '../../../components/my-projects/ProjectPlayerBlock/ProjectFolderTreeModalProvider';
import { videoFolderSelectors } from '../../../store/modules/videoFolder';
import { ApplicationState } from '../../../store/types';

export const ROOT_PATH = '/';

const LAST_SELECTED_FOLDER_KEY = 'last-stream-folder-id';
export const getLastSelectedFolderId = () => browserStore.get<number>(LAST_SELECTED_FOLDER_KEY);

const useSelectFolderPath = (initialFolderId?: number) => {
  const lastSelectedFolderId = getLastSelectedFolderId();
  const { openFolderTree, closeFolderTree, isFolderTreeModal } = useContext(ProjectFolderTreeModalContext);

  const currentFolder = useSelector(videoFolderSelectors.selectCurrentFolder);

  const [folderId, setFolderId] = useState(initialFolderId || lastSelectedFolderId || currentFolder?.id);

  useEffect(() => {
    !initialFolderId && !lastSelectedFolderId && setFolderId(currentFolder?.id);
  }, [initialFolderId, currentFolder?.id]);

  const folderPath = useSelector(state =>
    videoFolderSelectors.makeFolderPath(state as ApplicationState)(folderId || 0)
  );

  const path = folderPath?.toLowerCase() === 'root-wave' ? ROOT_PATH : `/${folderPath}`;

  const handleSetFolderId = useCallback((folderId: number) => {
    setFolderId(folderId);
    browserStore.set(LAST_SELECTED_FOLDER_KEY, folderId);

    closeFolderTree();
  }, []);

  const handleOpenTree = useCallback(() => {
    openFolderTree({
      customHeader: 'Save livestream to the folder:',
      rightButtonText: 'Save',
      onMoveFolder: handleSetFolderId,
      selectedFolderId: initialFolderId
    });
    analytic.trackNewStreamDialogClickSelectFolder();
  }, []);

  return [path, folderId, handleOpenTree, isFolderTreeModal] as const;
};

export default useSelectFolderPath;
